(() => {
  let frame;
  let nextId = 0;
  function enhance() {
    frame = null;
    document.querySelectorAll('.vm--modal:has(.tee-customization-image__link), .tee-dialog-gallery .vm--modal:has(#tee-popup-gallery)').forEach(modal => {
      if (modal.classList.contains('gp-design-preview')) return;
      const inner = modal.querySelector('.tee-dialog-inner');
      const originalClose = modal.querySelector('.tee-dialog-close');
      if (!inner || !originalClose) return;
      const gallery = modal.querySelector('#tee-popup-gallery');
      const productFooter = gallery && modal.querySelector('.tee-dcontent-footer');
      if (gallery && !productFooter) return;
      modal.classList.add('gp-design-preview');
      if (gallery) modal.classList.add('gp-product-preview');
      const opener = gallery ? document.querySelector('.tee-btn--preview') : document.activeElement;
      const close = () => {
        originalClose.click();
        if (typeof removeTrapFocus === 'function') removeTrapFocus(opener);
        if (opener?.isConnected) opener.focus({ preventScroll: true });
      };
      const title = document.createElement('h2');
      title.id = `gp-design-preview-title-${++nextId}`;
      title.className = 'visually-hidden';
      title.textContent = 'Preview';
      modal.setAttribute('aria-labelledby', title.id);
      const x = document.createElement('button');
      x.type = 'button'; x.className = 'gp-design-preview__x';
      x.setAttribute('aria-label', 'Close preview');
      x.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';
      x.addEventListener('click', close);
      inner.prepend(title, x);
      if (productFooter) {
        productFooter.classList.add('gp-design-preview__actions');
      } else {
        const footer = document.createElement('footer');
        footer.className = 'gp-design-preview__actions';
        const checkout = document.createElement('a');
        checkout.textContent = 'Proceed to Checkout';
        checkout.href = `${window.Shopify?.routes?.root || '/'}checkout`;
        footer.append(checkout); inner.append(footer);
      }
      modal.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(); }
      });
      if (typeof trapFocus === 'function') trapFocus(modal, x);
      else x.focus({ preventScroll: true });
      // Scale the complete app gallery, including artwork layers and controls,
      // rather than resizing individual mockup layers and shifting the design.
      let galleryObserver;
      let galleryFrame;
      if (gallery) {
        const fitGallery = () => {
          galleryFrame = null;
          const slider = gallery.querySelector('.tee-slider');
          const width = slider?.offsetWidth;
          if (!width || !modal.isConnected) return;
          const padding = getComputedStyle(inner);
          const availableWidth = inner.clientWidth - parseFloat(padding.paddingLeft) - parseFloat(padding.paddingRight);
          gallery.style.width = `${width}px`;
          const availableHeight = window.innerHeight - 64 - parseFloat(padding.paddingTop) - parseFloat(padding.paddingBottom) - productFooter.offsetHeight - 12;
          const scale = Math.min(1, availableWidth / width, availableHeight / gallery.offsetHeight);
          if (scale > 0) gallery.style.zoom = String(scale);
        };
        galleryObserver = new ResizeObserver(() => {
          if (!galleryFrame) galleryFrame = requestAnimationFrame(fitGallery);
        });
        galleryObserver.observe(inner);
        galleryObserver.observe(gallery);
        const slider = gallery.querySelector('.tee-slider');
        if (slider) galleryObserver.observe(slider);
        fitGallery();
      }
      // The app can also close via its backdrop; release the theme focus trap.
      const cleanup = new MutationObserver(() => {
        if (!modal.isConnected) {
          cleanup.disconnect();
          galleryObserver?.disconnect();
          if (galleryFrame) cancelAnimationFrame(galleryFrame);
          if (typeof removeTrapFocus === 'function') removeTrapFocus(opener);
        }
      });
      cleanup.observe(document.body, { childList: true, subtree: true });
      if (gallery) requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    });
  }
  new MutationObserver(() => {
    if (!frame) frame = requestAnimationFrame(enhance);
  }).observe(document.body, { childList: true, subtree: true });
  enhance();
})();
